import { render, staticRenderFns } from "./ScholarTable.vue?vue&type=template&id=5af1cf80&scoped=true&lang=pug&"
import script from "./ScholarTable.vue?vue&type=script&lang=js&"
export * from "./ScholarTable.vue?vue&type=script&lang=js&"
import style0 from "./ScholarTable.vue?vue&type=style&index=0&id=5af1cf80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af1cf80",
  null
  
)

export default component.exports